import * as L from 'leaflet';

import { MascaraUtil } from 'src/app/core/framework/utils/mascara-util';
import { StringUtil } from 'src/app/core/framework/utils/string-util';
import { PacienteLayoutUtil } from '../../paciente/util/paciente-layout.util';
import { ICoordenada, IEndereco } from './endereco.interface';
import { GeocodeReversoResult } from './gis/model/google-maps-geocode-reverso-result.interface';


export class EnderecoUtil {

  criarEnderecoVazio(): IEndereco {
    return {
      // geom: {
      //   coordinates: {
      //     lat: '',
      //     lng: ''
      //   }
      // }
      geom: null
      , logradouro: ''
      , bairro: ''
      , cep: ''
      , cidade: null
      , estado: null
      , complemento: ''
      , numero: ''
      , pais: ''
    }
  }

  static verificarGeomNoEndereco(endereco: IEndereco): boolean {
    if ( !endereco ) {
      return false;
    }

    if ( !endereco.geom ||
      !endereco.geom.coordinates ||
      !endereco.geom.coordinates.lat ||
      !endereco.geom.coordinates.lng ) {
      return false;
    }

    return true;
  }

  static verificarEndereco(endereco: IEndereco): boolean {
    if ( !endereco ) {
      return false;
    }

    if ( !EnderecoUtil.verificarGeomNoEndereco(endereco) ) {
      return false;
    }

    if ( !endereco.cep ) {
      return false;
    }

    return true;
  }

  static isEnderecoVazio(endereco: IEndereco): boolean {
    if ( !endereco ) {
      return true;
    }

    if ( endereco.estado ||
         endereco.cidade || 
         endereco.bairro ||
         endereco.logradouro ||
         endereco.cep ||
         endereco.complemento ||
         endereco.numero ||
         endereco.geom ) {
          return false;
         }
    
    return true;
  }

  mascaraCEP(cep: string): string {
    let cepARetornar = '';
    if ( cep ) {
      if ( cep.length === 8 ) {
        cepARetornar = cep.substring(0, 5) + '-' + cep.substring(5, 8);
      }
      else {
        cepARetornar = cep;
      }
    }

    return cepARetornar;
  }

  toString(pEndereco: IEndereco, limite?: number): string {
    const rua = pEndereco.logradouro;
    const bairro = pEndereco.bairro;
    const cidade = pEndereco.cidade;
    const estado = pEndereco.estado;
    const cep    = pEndereco.cep || '';

    let endereco = '';
    if ( !EnderecoUtil.isEnderecoVazio( pEndereco ) ) {
      if (rua) {
        endereco += rua;
      }
      if (bairro) {
          endereco += ( endereco ? ', ' : '' );
          endereco += bairro;
      }
      if (cidade && cidade.nome) {
          endereco += ( endereco ? ', ' : '' );
          endereco += cidade.nome;
      }
      if (estado && ( estado.nome || estado.sigla )) {
          endereco += ( endereco ? ', ' : '' );
          if ( estado.sigla ) {
            endereco += estado.sigla;
          }
          else if ( estado.nome ) {
            endereco += estado.nome;
          }
      }

      if ( cep ) {
        endereco += ( endereco ? ', ' : '' );
        endereco += 'CEP ' + this.mascaraCEP(cep);
      }

      if (limite) {
        return endereco.substr(0, limite) + (endereco.length > limite ? '...' : '');
      }

      return endereco;
    }
  }

  abreviarEndereco(endereco: IEndereco, maxLength?: number): string {
    maxLength = (maxLength ? maxLength : 21);

    let o = '';
    if ( !EnderecoUtil.isEnderecoVazio( endereco ) ) {
      if ( endereco.logradouro ) {
        o += StringUtil.abreviar(endereco.logradouro, maxLength);
      }

      if ( endereco.bairro ) {
        o += o ? ', ' : '';
        o += StringUtil.abreviar(endereco.bairro, maxLength);
      }

      if ( endereco.cidade && endereco.cidade.nome ) {
        o += o ? ', ' : '';
        o += StringUtil.abreviar(endereco.cidade.nome, maxLength)
      }
    }

    return o;
  }

  extrairEnderecoDoGoogleGeocodeReversoSemCidadeEEstado(result: GeocodeReversoResult): IEndereco {
    let numero: string = '';
    let logradouro: string = '';
    let bairro: string = '';
    let cep: string = '';
    let coordenada: ICoordenada = {
      lat: '',
      lng: ''
    };

    if ( result && result.results && result.results.length > 0 ) {
      const root = result.results[0];

      for ( const addressComponent of root.address_components ) {
        if ( addressComponent.types.indexOf('street_number') >= 0 ) {
          numero = addressComponent.short_name;
        }
        else if ( addressComponent.types.indexOf('route') >= 0 ) {
          logradouro = addressComponent.short_name;
        }
        else if ( addressComponent.types.indexOf('sublocality_level_1') >= 0 ) {
          bairro = addressComponent.short_name;
        }
        else if ( addressComponent.types.indexOf('postal_code') >= 0 ) {
          const _cep = StringUtil.extrairNumeros(addressComponent.short_name);
          cep = ( _cep ? '' + _cep : '' );
        }
      }

      if ( root.geometry && root.geometry.location ) {
        coordenada.lat = '' + root.geometry.location.lat;
        coordenada.lng = '' + root.geometry.location.lng
      }
    }

    const _endereco: IEndereco = {
      logradouro: logradouro,
      geom: {
        coordinates: coordenada
      },
      numero: numero,
      bairro: bairro,
      cep: cep
    };

    return _endereco;
  }

  public getEnderecoEstilizado(endereco: IEndereco, telefone: string, abreviar?: boolean /*, exibirTagsDeAviso?: boolean*/ ): any {
    let str = '';
    let _endereco = '';
    let _telefone = '';

    // telefone
    if ( telefone ) {
      _telefone = `<label style='color: #5c6bc0 !important; font-size: 13px !important; margin-bottom: 3px !important; display: block !important;'>${MascaraUtil.mascaraDeTelefone(telefone)}</label>`
    }

    // endereco
    if ( !EnderecoUtil.isEnderecoVazio( endereco ) ) {
      const enderecoAbreviado = this.abreviarEndereco(endereco, 42);
      const enderecoCompleto = this.toString(endereco);

      _endereco = `<label
                    title='${enderecoCompleto}'
                    style='color: #777777 !important; font-size: 12px !important;'>
                    ${ (!!abreviar ? enderecoAbreviado : enderecoCompleto) }
                  </label>`;

      if ( !EnderecoUtil.verificarGeomNoEndereco(endereco) ) {
        _endereco += ( enderecoAbreviado || enderecoCompleto ? '&nbsp;' : '' );
        _endereco += '<label class="tag tag-warning">Sem coordenada</label>';
      }
    }
    else {
      _endereco = PacienteLayoutUtil.tagSemEndereco;
    }

    str = `<span style='display: block !important; margin-top:6px !important;'>
            ${_telefone}
            ${_endereco}
          </span>`

    return str;
  }

  public static converterLatLngsParaICoordenadas(latLngs: L.LatLng[]): ICoordenada[] {
    const coordenadas: ICoordenada[] = [];
    latLngs.forEach(ll => coordenadas.push(EnderecoUtil.converterLatLngParaICoordenada(ll)));
    
    return coordenadas;
  }

  public static converterLatLngParaICoordenada(latLng: L.LatLng): ICoordenada {
    return {
      lat: '' + latLng.lat,
      lng: '' + latLng.lng
    };
  }

}
